import { useContext, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { VendasContext } from "../context/VendasContext";


export default function ContainerLegend() {

    const { sales } = useContext(VendasContext);
    const { itemsPerPage, setItemsPerPage } = useContext(VendasContext);
    const { currentPage, setCurrentPage } = useContext(VendasContext);
    const { totalItems, setTotalItems } = useContext(VendasContext);


    useEffect(() => {
        setTotalItems(sales.length);
    }, [sales]);


    const inicio = totalItems === 0 ? 0 : (currentPage * itemsPerPage) - itemsPerPage + 1;
    const fim = currentPage * itemsPerPage >= totalItems ? totalItems : currentPage * itemsPerPage;
    const isFirst = currentPage === 1;
    const isLast = currentPage * itemsPerPage >= totalItems;


    return (
        <div className="surface-card flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 text-sm">

            <div className="text-ink-3 tabular-nums">
                Exibindo <span className="font-medium text-ink-1">{inicio}</span>–<span className="font-medium text-ink-1">{fim}</span> de <span className="font-medium text-ink-1">{totalItems}</span>
            </div>

            <div className="flex items-center gap-2">
                <label className="text-2xs uppercase tracking-wider text-ink-4 mr-1">Por página</label>
                <select
                    value={itemsPerPage}
                    onChange={(e) => {
                        setItemsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                    }}
                    className="bg-surface-3 border border-white/[0.08] hover:border-white/[0.14] rounded-lg px-2 py-1 text-sm tabular-nums focus:border-brand-500/60 focus:ring-2 focus:ring-brand-500/15 outline-none transition"
                >
                    {[10, 20, 50].map((n) => <option key={n} value={n}>{n}</option>)}
                </select>

                <div className="flex items-center gap-1 ml-2">
                    <button
                        type="button"
                        disabled={isFirst}
                        onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                        className="h-8 w-8 grid place-items-center rounded-lg text-ink-3 hover:bg-white/[0.04] hover:text-ink-1 transition disabled:opacity-30 disabled:pointer-events-none"
                        aria-label="Página anterior"
                    >
                        <ChevronLeft className="h-4 w-4" />
                    </button>

                    <span className="text-xs text-ink-4 px-2 tabular-nums min-w-[40px] text-center">
                        {currentPage}
                    </span>

                    <button
                        type="button"
                        disabled={isLast}
                        onClick={() => setCurrentPage(p => Math.min(totalItems, p + 1))}
                        className="h-8 w-8 grid place-items-center rounded-lg text-ink-3 hover:bg-white/[0.04] hover:text-ink-1 transition disabled:opacity-30 disabled:pointer-events-none"
                        aria-label="Próxima página"
                    >
                        <ChevronRight className="h-4 w-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}
